import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

export const ANKETA_TITLES = {
  [PRODUCT_TYPES_VALUES.CREDIT]: 'Заявка на кредит',
  [PRODUCT_TYPES_VALUES.CREDIT_CARD]: 'Подбор кредитной карты',
  [PRODUCT_TYPES_VALUES.MICRO_CREDIT]: 'Заявка на кредит',
};
